export const dashboardHideProcessLeadsLocalStorageKey =
  'dashboard-hideProcessedLeads';
